<template src="./vehicleoverview.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import Task from "@/pages/task/task";
export default {
  components: {
    UpcomingEvent,
    Task,
  },
  props: {
    RequestFor: String,
    Title: String,
    todaysUrgentTaskNew: Boolean,
  },
  data() {
    return {
      UpcomingEvent: {},
      DashboardData: {},
      DashboardReport: {},
      DashboardReportData: {},
      CalenderEvent: [],
      OtherData: [],
      excel_data: [],
      excel_title: "",
      VehicleWarningCnt: 0,
      ShowDashboardReportDetailLoader: false,
    };
  },
  mounted() {
    this.GetDashBoardReport();
    //this.GetUpcomingEventList();
  },
  methods: {
    exportActionNeeded() {
      this.$refs.upcoming_events2.exportActionNeeded();
    },
    exportUrgentTask() {
      this.$refs.urgent_task.exportActionNeeded();
    },
    GetDashBoardReport() {
      var Type = "vehicle";
      if (this.RequestFor == "AssetsList") {
        Type = "assets";
      }
      Axios.post(Endpoints.Dashboard.DashboardReport, {
        token: localStorage.getItem("token"),
        type: Type,
        item_type: this.RequestFor,
      }).then((Response) => {
        if (Response.data.success) {
          this.DashboardReport = Response.data.DashboardReport;
        }
      });
    },
    ShowDashboardReportDetail(type) {
      this.ShowDashboardReportDetailLoader = true;
      Axios.post(Endpoints.Dashboard.DashboardReportData, {
        token: localStorage.getItem("token"),
        type: type,
        item_type: this.RequestFor,
      }).then((Response) => {
        this.ShowDashboardReportDetailLoader = false;
        if (Response.data.success) {
          this.DashboardReportData = Response.data.DashboardReportData;
          this.excel_data = [];

          if (type == "vehiclesafe" && this.RequestFor == "VehicleList") {
            if (this.DashboardReportData.VehicleSafeArr.length > 0) {
              this.DashboardReportData.VehicleSafeArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element.driver) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                }
                if (!element.driver) {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "safe-vehicle-list";
          }
          if (type == "vehicleunsafe" && this.RequestFor == "VehicleList") {
            if (this.DashboardReportData.VehicleUnSafeArr.length > 0) {
              this.DashboardReportData.VehicleUnSafeArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element.driver) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                }
                if (element.driver_name) {
                  obj["Driver"] = element.driver_name;
                }
                if (!element.driver_name && !element.driver) {
                  obj["Driver"] = "N/A";
                }
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "unsafe-vehicle-list";
          }
          if (type == "vehiclewarning" && this.RequestFor == "VehicleList") {
            if (this.DashboardReportData.VehicleWarningArr.length > 0) {
              this.DashboardReportData.VehicleWarningArr.forEach((element) => {
                var obj = {};
                obj["Vehicle"] = element.vrm;
                if (element.driver) {
                  obj["Driver"] =
                    element.driver.driver.forename +
                    " " +
                    element.driver.driver.surname;
                }
                if (!element.driver) {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "vehicle-warning-list";
          }
          if (type == "vehiclesafe" && this.RequestFor == "TrailerList") {
            if (this.DashboardReportData.VehicleSafeArr.length > 0) {
              this.DashboardReportData.VehicleSafeArr.forEach((element) => {
                var obj = {};
                obj["Trailer"] = element.vrm;
                if (element.get_trailer != null) {
                  obj["Vehicle"] = element.get_trailer.trailer_data.vrm;
                } else {
                  obj["Vehicle"] = "N/A";
                }

                if (
                  element.get_trailer != null &&
                  element.get_trailer.trailer_data.driver
                ) {
                  obj["Driver"] =
                    element.get_trailer.trailer_data.driver.driver.forename +
                    " " +
                    element.get_trailer.trailer_data.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "safe-trailer-list";
          }
          if (type == "vehicleunsafe" && this.RequestFor == "TrailerList") {
            if (this.DashboardReportData.VehicleUnSafeArr.length > 0) {
              this.DashboardReportData.VehicleUnSafeArr.forEach((element) => {
                var obj = {};
                obj["Trailer"] = element.vrm;
                if (element.get_trailer != null) {
                  obj["Vehicle"] = element.get_trailer.trailer_data.vrm;
                } else {
                  obj["Vehicle"] = "N/A";
                }
                if (
                  element.get_trailer != null &&
                  element.get_trailer.trailer_data.driver
                ) {
                  obj["Driver"] =
                    element.get_trailer.trailer_data.driver.driver.forename +
                    " " +
                    element.get_trailer.trailer_data.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "unsafe-trailer-list";
          }
          if (type == "vehiclewarning" && this.RequestFor == "TrailerList") {
            if (this.DashboardReportData.VehicleWarningArr.length > 0) {
              this.DashboardReportData.VehicleWarningArr.forEach((element) => {
                var obj = {};
                obj["Trailer"] = element.vrm;
                if (element.get_trailer != null) {
                  obj["Vehicle"] = element.get_trailer.trailer_data.vrm;
                } else {
                  obj["Vehicle"] = "N/A";
                }
                if (
                  element.get_trailer != null &&
                  element.get_trailer.trailer_data.driver
                ) {
                  obj["Driver"] =
                    element.get_trailer.trailer_data.driver.driver.forename +
                    " " +
                    element.get_trailer.trailer_data.driver.driver.surname;
                } else {
                  obj["Driver"] = "N/A";
                }
                obj["Reason"] = element.unsafe_reason;
                this.excel_data.push(obj);
              });
            }
            this.excel_title = "vehicle-warning-list";
          }        
        }
      });
    },
    GetUpcomingEventList() {
      Axios.post(Endpoints.Dashboard.UpcomingEvent, {
        token: localStorage.getItem("token"),
        RequestFor: this.RequestFor,
      }).then((Response) => {
        if (Response.data.success) {
          this.UpcomingEvent = Response.data.upcoming_event;
          this.CalenderEvent = Response.data.calender_event;
          this.OtherData = Response.data.other_data;
          var ActionsNeededCount = 0;
          this.CalenderEvent.forEach((element, index) => {
            if (element.status == "red") {
              ActionsNeededCount++;
            }
            if (element.status == "yellow") {
              ActionsNeededCount++;
            }
          });
          if (document.getElementById("ActionsNeededCount")) {
            document.getElementById("ActionsNeededCount").innerHTML =
              ActionsNeededCount;
            if (this.OtherData.redStatusCnt >= 1) {
              document.getElementsByClassName("urgent-task-btn")[0].innerHTML =
                this.OtherData.redStatusCnt + " Urgent Tasks Required";
              document.getElementsByClassName(
                "urgent-task-btn"
              )[0].style.display = "block";
            } else {
              document.getElementsByClassName(
                "urgent-task-btn"
              )[0].style.display = "none";
            }
          }
        }
        this.VehicleWarningCnt = 0;
        var VehicleWarningArr = [];
        for (var i = 0; i < this.UpcomingEvent.length; i++) {
          if (
            (this.UpcomingEvent[i]["type"] == "vehicle" ||
              this.UpcomingEvent[i]["type"] == "vehiclecheck") &&
            (this.UpcomingEvent[i]["status"] == "yellow" ||
              this.UpcomingEvent[i]["status"] == "orange")
          ) {
            //this.VehicleWarningCnt = this.VehicleWarningCnt + 1;
            VehicleWarningArr[this.UpcomingEvent[i]["vrm"]] =
              this.UpcomingEvent[i]["vrm"];
          }
        }
        this.VehicleWarningCnt = Object.keys(VehicleWarningArr).length;
      });
    },
   
  },
};
</script>
<style scoped>
.btn.vehicle-task-required {
  position: absolute;
  right: 10px;
  top: 3px;
  font-size: 9px !important;
}
.display-inline {
  display: inline-block !important;
}
.modal-footer {
  text-align: right !important;
}
</style>
